var _defs, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLayer2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 503 505.78",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{fill:#0a0a0a;stroke-width:3px;}.cls-1,.cls-3,.cls-6{stroke:#fff;}.cls-1,.cls-2,.cls-3,.cls-5,.cls-6{stroke-miterlimit:10;}.cls-2,.cls-5{stroke:#8f00ff;}.cls-3{fill:#8f00ff;}.cls-3,.cls-5,.cls-6{stroke-width:2px;}.cls-4{fill:#fff;}.cls-5,.cls-6{fill:none;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M428.67,260.61a166.67,166.67,0,1,0,0,333.33h.07A166.63,166.63,0,0,1,595.26,430.06c0-.93.07-1.85.07-2.78A166.67,166.67,0,0,0,428.67,260.61Z",
    transform: "translate(-260.5 -259.11)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M595.33,430.06h-.07A166.63,166.63,0,0,1,428.74,593.94c0,.93-.07,1.85-.07,2.78A166.67,166.67,0,1,0,595.33,430.06Z",
    transform: "translate(-260.5 -259.11)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLayer2);
export default __webpack_public_path__ + "static/media/layer2.df0c237a1b6d39f485334be547d5438f.svg";
export { ForwardRef as ReactComponent };